<template>
  <div
    class="space-y-8"
    :class="{ 'opacity-50 pointer-events-none': isPending }"
  >
    <div
      v-if="isError && error"
      severity="error"
      class="bg-red-100 border-red-500 p-2 border text-black"
    >
      {{ getErrorMessage(error) }}
    </div>
  </div>

  <div v-if="isPending"><KlereoSpinner /></div>
</template>

<script setup lang="ts">
import { UseMutationReturnType } from "@tanstack/vue-query";
import KlereoSpinner from "@/shared/components/KlereoSpinner.vue";
import { getErrorMessage } from "@/shared/utils/error";

const props = defineProps<{
  mutation: UseMutationReturnType<any, Error, any, any>;
}>();

const { isPending, isError, error } = props.mutation;
</script>
